<template>
    <button
        type="button"
        :class="[
            {
                'border-red': $validator.has(validatorName, sid)
            },
            is_checked
                ? 'bg-blue-lightest border-blue hover:border-blue-darker'
                : 'hover:border-grey',
            {
                'cursor-not-allowed': disabled,
                'bg-grey-bg': disabled && !is_checked,
                'focus:shadow-outline': !disabled
            }
        ]"
        class="block p-3 text-left border rounded cursor-pointer focus:outline-none"
        @click="onClick"
    >
        <div class="flex items-center">
            <div class="flex-grow leading-none">
                <slot name="label">Label</slot>
            </div>

            <base-svg
                :class="is_checked ? 'block' : 'hidden'"
                name="icon-check-circle"
                class="flex-none w-4 h-4 fill-primary-blue-dark fill-secondary-blue-lighter"
            />
        </div>

        <div
            v-if="!!$slots['hint']"
            class="mt-2 text-sm leading-tight text-grey-darker"
        >
            <slot name="hint" />
        </div>
    </button>
</template>

<script>
    export default {
        model: {
            prop: 'model',
            event: 'input'
        },
        props: {
            model: {
                validator: value => typeof value === 'string' || value === null,
                default: null
            },
            value: {
                validator: value => typeof value === 'string' || value === null,
                default: null
            },
            sid: {
                type: String,
                default: null
            },
            name: {
                type: String,
                required: true
            },
            validatorName: {
                type: String,
                required: false,
                default () {
                    return this.name.replace('[', '.').replace(']', '')
                }
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            is_checked () {
                return this.model === this.value
            }
        },
        methods: {
            onClick () {
                if (!this.disabled) {
                    this.$emit('input', this.value)
                }
            }
        }
    }
</script>
